import React from "react";
import { t } from "i18next";
import { getMany, softDeleteById } from "services/shift";
import { Util } from "common/util";
import withDataTable from "../withDataTable";

const util = new Util();
const pathName = "/setting/shift";
const columns = [
  {
    title: t("text_shift_name"),
    dataIndex: "name",
    key: "name",
  },
  {
    title: t("text_shift_from"),
    dataIndex: "workingTimeIn",
    key: "workingTimeIn",
    render: (workingTimeIn) =>
      workingTimeIn && util.getTimeClock(workingTimeIn),
  },
  {
    title: t("text_shift_to"),
    dataIndex: "workingTimeOut",
    key: "workingTimeOut",
    render: (workingTimeOut) =>
      workingTimeOut && util.getTimeClock(workingTimeOut),
  },
  {
    title: t("text_shift_margin"),
    dataIndex: "isEnableShiftMargin",
    key: "isEnableShiftMargin",
    render: (isEnableShiftMargin) => {
      if (isEnableShiftMargin === true) {
        return (
          <div className="shift-flexbox">
            <div className="shift-margin-enable"></div>
            <span>{t("text_shift_enable")}</span>
          </div>
        );
      } else {
        return (
          <div className="shift-flexbox">
            <div className="shift-margin-disable"></div>
            <span>{t("text_shift_disable")}</span>
          </div>
        );
      }
    },
  },
];

const size = new URLSearchParams(document.location.search).get("size");
const current = new URLSearchParams(document.location.search).get("current");
let defaultCurrent = 1;
let defaultPageSize = 20;

if (current) {
  defaultCurrent = current;
}

if (size) {
  defaultPageSize = size;
}

const getData = () => {
  let limit = defaultPageSize;
  let current = defaultCurrent;
  let option = {};
  const params = new URLSearchParams(document.location.search);
  const searchStr = params.get("search");

  if (params.get("size")) {
    limit = params.get("size");
  }

  if (params.get("current")) {
    current = params.get("current");
  }

  option["limit"] = limit;
  option["offset"] = (current - 1) * limit;

  if (searchStr) {
    option["search"] = searchStr;
  }

  return getMany(option);
};

const handleSearch = (e) => {
  const queryParams = new URLSearchParams(document.location.search);
  const value = e.target.value;
  if (value) {
    queryParams.set("search", value);
  } else {
    queryParams.delete("search");
  }
  util.pushParamsToURL(pathName, queryParams.toString());
};

export default withDataTable({
  title: t("text_shift"),
  showPagination: true,
  columns,
  defaultCurrent,
  defaultPageSize,
  getData,
  handleSearch,
  pathName,
  addNewLink: "/setting/shift/create",
  updateLink: "/setting/shift/update",
  confirmSoftDelete: (id) => softDeleteById(id),
});
